import api from '../api';

// MIGRATION: Independent agents now use the unified /payment-reminders
// endpoints. Create/update field names match directly. Two differences are
// adapted here so the existing Independent UI needs no changes:
//  - GET / wraps the list as { success, data: [...] } instead of a plain
//    array
//  - each reminder only has client_first_name/client_last_name (parsed from
//    the client's lead_traveler JSON) instead of a single client_name field
const fromUnifiedReminder = (reminder) => {
  if (!reminder || typeof reminder !== 'object') return reminder;
  const firstName = reminder.client_first_name || '';
  const lastName = reminder.client_last_name || '';
  return {
    ...reminder,
    client_name: `${firstName} ${lastName}`.trim()
  };
};

export const independentPaymentRemindersService = {
  getAll: async () => {
    const response = await api.get('/payment-reminders');
    const list = Array.isArray(response.data) ? response.data : (response.data?.data || []);
    return list.map(fromUnifiedReminder);
  },

  getById: async (id) => {
    const response = await api.get(`/payment-reminders/${id}`);
    return fromUnifiedReminder(response.data);
  },

  create: async (reminderData) => {
    const response = await api.post('/payment-reminders', reminderData);
    return response.data;
  },

  update: async (id, reminderData) => {
    const response = await api.put(`/payment-reminders/${id}`, reminderData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/payment-reminders/${id}`);
    return response.data;
  },

  sendNow: async (id) => {
    const response = await api.post(`/payment-reminders/${id}/send`);
    return response.data;
  }
};

export default independentPaymentRemindersService;
